import { Skeleton } from "@/components/states";
import { Card, CardContent, CardHeader } from "@/components/ui/card";

/**
 * Stat tile: label · compact value · optional signed delta vs a named period.
 * Delta color = direction x whether up is good. Values use the font's default
 * proportional figures (tabular-nums is reserved for table columns).
 * An undefined value renders as a shimmer placeholder while data loads.
 */
export function StatCard({
  label,
  value,
  delta,
}: {
  label: string;
  value?: string | null;
  delta?: { text: string; direction: "up" | "down"; upIsGood?: boolean };
}) {
  const deltaIsGood =
    delta && (delta.direction === "up") === (delta.upIsGood ?? true);
  return (
    <Card>
      <CardHeader className="pb-2">
        <div className="text-sm text-muted-foreground">{label}</div>
      </CardHeader>
      <CardContent>
        {value == null ? (
          <Skeleton className="h-9 w-20" />
        ) : (
          <div className="text-3xl font-semibold">{value}</div>
        )}
        {delta ? (
          <div
            className="mt-1 text-xs"
            style={{
              color: deltaIsGood ? "var(--viz-delta-good)" : "var(--viz-delta-bad)",
            }}
          >
            {delta.text}
          </div>
        ) : null}
      </CardContent>
    </Card>
  );
}
